import { Helmet } from "react-helmet";
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Container,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Toolbar,
    Typography,
    Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ApexCharts from "react-apexcharts";
import bannerBg from "../../../assets/images/home/home-banner-bg.svg";
import bannerImg from "../../../assets/images/home/banner-image.svg";
import planningImg from "../../../assets/images/home/planning.svg";
import saveImg from "../../../assets/images/home/save.svg";
import fileBrowser from "../../../icons/file-browser.svg";
import { makeStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import cssVariables from "../../../theme/cssVariables";
import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ReactComponent as PlusIcon } from "../../../icons/plus.svg";
import AttachFilesDialog from "../../../components/workloadAndPerformance/AttachFilesDialog";
import { ReactComponent as TrashIcon } from "../../../assets/images/portfolio/trash-alt.svg";
import core from "../../../assets/images/competency/core.svg";
import coreBlack from "../../../assets/images/competency/core-black.svg";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import StarIcon from '@mui/icons-material/StarOutlined';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from "@mui/styles";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { ReactComponent as TooltipIcon } from "../../../assets/images/tooltip.svg";
import { ReactComponent as DownIcon } from "../../../assets/images/competency/chevrons-down.svg";
import { ReactComponent as UpIcon } from "../../../assets/images/competency/chevrons-up.svg";
import StepAssignCompetency from "../../../views/app/kpi/StepAssignCompetency";


const useStyles = makeStyles({
    outlineGrayBtn: {
        height: '35px'
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    icon: {
        paddingRight: "10px"
    },
    fill: {
        '& > path': {
            fill: "black"
        },
        '& g > path': {
            fill: "black"
        },
    },
    blueBg: {
        background: "#4085C9",
    },
    purpleBg: {
        background: "#7580BD",
    },
    scroll: {
        '&::-webkit-scrollbar': {
            width: "4px",
            backgroundColor: "#C4C4C4",
            borderRadius: "10px",
        },
        '&::-webkit-scrollbar-track': {
            '-webkit-box-shadow': "none",
            borderRadius: "10px",
            backgroundColor: "#EFEFEF"
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: "10px",
            '-webkit-box-shadow': "none",
            backgroundColor: "#C4C4C4",
        }
    }
});
const Ratings = styled(Rating)({
    '& .MuiRating-icon': {
        color: '#F7B254 !important',
    },
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    fill: {
        '& > path': {
            fill: "black"
        },
        '& g > path': {
            fill: "black"
        },
    },
};
const AssignCompetency = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    useEffect(() => {
    }, []);
    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    let { serial } = useParams();
    
    return (
        <>
            <Helmet>
                <title>HOME | KPI </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: "background.default",
                    minHeight: "100%",
                    py: 3,
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.link} onClick={() => clickLink(`/kpi/competency/${serial}`)}>My Competency</span> / <span style={styles.end} >Assign Competency</span></Typography>
                    </Grid>
                    <Grid container spacing={4}>
                        <Grid item lg={12} md={12} xs={12}>
                            <Card sx={{ height: 1 }}>
                                <CardContent>
                                    <Grid container >
                                        <Grid item xs={12} display="flex" justifyContent="center">
                                            <Typography fontSize={14} lineHeight="24px" fontWeight="400" sx={{ color: "#AAAAAA" }}>
                                                step
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sx={{ paddingTop: "20px!important" }}>
                                            <Divider />
                                        </Grid>
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            xs={12}
                                        >
                                            <Grid container display="flex" justifyContent="center">
                                                <StepAssignCompetency />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    );
};
export default AssignCompetency;
